import React from 'react';
import { Box, Typography } from '@mui/material';
import '../../../styles/bankTokens.css';

const displayOf = (value) => (value == null || value === '' ? '—' : String(value).trim());

/**
 * One labelled figure in a reconciliation header bar (bank matching, card matching).
 * `accent` tints the value, e.g. a difference that has to be cleared.
 */
const MetricChip = ({ label, value, accent }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            lineHeight: 1.2,
            px: 1,
            py: 0.4,
            borderRadius: 'var(--bank-radius-sm, 8px)',
            backgroundColor: 'var(--bank-surface-muted, #f7f8fc)',
            minWidth: 0,
        }}
    >
        <Typography
            sx={{
                fontSize: '0.62rem',
                fontWeight: 600,
                color: 'var(--bank-text-muted, #6b7186)',
                whiteSpace: 'nowrap',
            }}
        >
            {label}
        </Typography>
        <Typography
            sx={{
                fontSize: '0.82rem',
                fontWeight: 700,
                color: accent || 'var(--bank-text, #1f2437)',
                whiteSpace: 'nowrap',
                fontVariantNumeric: 'tabular-nums',
            }}
        >
            {displayOf(value)}
        </Typography>
    </Box>
);

/** Shared container look for a header bar built out of MetricChips. */
export const metricBarSx = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
    px: 1.25,
    py: 0.75,
    backgroundColor: 'var(--bank-surface, #fff)',
    border: '1px solid var(--bank-border, #e4e7f2)',
    borderRadius: 'var(--bank-radius, 12px)',
    boxShadow: 'var(--bank-shadow, 0 2px 8px rgba(0, 0, 0, 0.08))',
};

export default MetricChip;
